import forEach from 'lodash/forEach';
import * as Rx from 'rx-dom';
import Promise from 'bluebird';
function HttpService() {
    return function (config) {
        if (!config.url) {
            return Promise.reject('Must set an URL!');
        }
        if (!config.dataType) {
            config.dataType = 'json';
        }
        var headers = {
            accept: 'application/json; odata=verbose',
            'content-type': 'application/octet-stream',
            'x-requestdigest': config.digest || document.getElementById('__REQUESTDIGEST').value
        };
        if (config.dataType == 'json') {
            headers['content-type'] = 'application/json';
        }
        forEach(config.headers, function (value, key) {
            if (value === undefined) {
                delete headers[key.toLocaleLowerCase()];
            }
            else {
                headers[key.toLocaleLowerCase()] = value;
            }
        });
        var method = config.method || 'GET';
        if (method.toLocaleUpperCase() == 'GET') {
            if (config.url.indexOf('?') > -1) {
                config.url += '&';
            }
            else {
                config.url += '?';
            }
            config.url += "_rev=" + Math.random().toString().substr(2);
        }
        return new Promise(function (resolve, reject) {
            var request = function (url) {
                return Rx.DOM.ajax({
                    method: method,
                    url: url,
                    headers: headers,
                    body: config.dataType == 'json' ? JSON.stringify(config.data) : config.data,
                    crossDomain: true
                })
                    .first()
                    .subscribe(function (value) {
                    if (value.status >= 200 && value.status < 300) {
                        try {
                            var data = null;
                            if (value.status == 204) {
                            }
                            else {
                                if (config.dataType == 'json') {
                                    data = JSON.parse(value.response);
                                }
                                else if (config.dataType == 'xml') {
                                    data = value.xhr.responseXML;
                                }
                                else {
                                    data = value.response;
                                }
                            }
                            var result = { data: data };
                            resolve(result);
                        }
                        catch (ex) {
                            reject(ex);
                        }
                    }
                    else if (value.status === 301 && value.xhr.getResponseHeader('location')) {
                        request(value.xhr.getResponseHeader('location'));
                    }
                    else {
                        reject(value.response);
                    }
                }, function (response) {
                    var error;
                    try {
                        var resp = JSON.parse(response.xhr.responseText);
                        error = new Error(resp.error.message.value);
                    }
                    catch (ex) {
                        error = new Error(response.xhr.responseText);
                    }
                    error.status = response.status;
                    error.originalEvent = response.originalEvent;
                    error.type = response.type;
                    error.xhr = response.xhr;
                    reject(error);
                });
            };
            request(config.url);
        });
    };
}
var $http = HttpService();
export default $http;
